<template>
  <div class="application-pending-container">
    <span class="application-pending-message">
      Your progress on the Chargebee Pay setup was saved 🙌🏻.
    </span>
    <div class="resume-button-wrapper">
      <c-button @click="navigateTo" variant="primary">
        <span class="resume-button-text">Resume Setup</span>
      </c-button>
    </div>
  </div>
</template>

<script>
import { navigateTo } from "@/router";
import { RouteConstants } from "@/router/routeConstants";

export default {
  name: "ApplicationPending",
  methods: {
    navigateTo() {
      navigateTo(RouteConstants.INCREMENTAL_ONBOARDING);
    },
  },
};
</script>

<style lang="scss">

.application-pending-container {
  display: flex;
  flex-direction: column;

  .application-pending-message {
    text-align: left;
    font-size: 14px;
  }

  .resume-button-wrapper {
    margin-top: 4px;
    font-size: 14px;

    .c-button {
      display: flex;

      .c-button__label {
        padding: unset !important;
      }

      .resume-button-text {
        display: flex;
      }

      .button-label {
        display: flex;
        align-items: center;
        font-weight: $fw_medium;
      }
    }
  }
}

</style>
